<section class="pt-16 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Utenti', route: '/backoffice/utenti' }, { label: 'Modifica Utente', active: true }]"></app-breadcrumb-backoffice>
</section>

<section class="px-container pb-16">
    <form [formGroup]="formUtente" class="accrediti-form flex flex-col gap-6" (ngSubmit)="onSubmit()">
        <div class="ac-section-head">
            <h2>Dati utente</h2>
            <span class="ac-meta">credenziali e ruolo</span>
        </div>

        <div class="flex lg:flex-row flex-col gap-4">
            <div class="fld flex-1">
                <label>* Username</label>
                <input type="text" pInputText class="w-full" placeholder="Username" formControlName="username" required />
                <small class="text-red-600 block mt-2 font-medium" *ngIf="formUtente.get('username')?.hasError('required') && (formUtente.get('username')?.dirty || formUtente.get('username')?.touched)">L'username è obbligatorio.</small>
            </div>
            <div class="fld flex-1">
                <label>Email (<i>opzionale</i>)</label>
                <input type="text" pInputText class="w-full" placeholder="Email" formControlName="email" />
                <small class="text-red-600 block mt-2 font-medium" *ngIf="formUtente.get('email')?.hasError('email') && (formUtente.get('email')?.dirty || formUtente.get('email')?.touched)">Inserire un'email valida.</small>
            </div>
        </div>

        <div class="flex lg:flex-row flex-col gap-4">
            <div class="fld flex-1">
                <label>Nuova password (<i>opzionale</i>)</label>
                <p-password [toggleMask]="true" formControlName="password" placeholder="Nuova password" [feedback]="false" styleClass="w-full" inputStyleClass="w-full" autocomplete />
                <small class="text-gray-500 block mt-2">{{ passwordHint }} (lascia vuoto per non cambiarla)</small>
                <small class="text-red-600 block mt-2 font-medium" *ngIf="formUtente.get('password')?.hasError('strongPassword')">{{ passwordHint }}</small>
                <small class="text-red-600 block mt-2 font-medium" *ngIf="formUtente.hasError('mismatch') && (formUtente.get('password')?.dirty || formUtente.get('password')?.touched) && (formUtente.get('confirm_password')?.dirty || formUtente.get('confirm_password')?.touched)">Le due password non combaciano.</small>
            </div>
            <div class="fld flex-1">
                <label>Conferma nuova password (<i>opzionale</i>)</label>
                <p-password [toggleMask]="true" formControlName="confirm_password" placeholder="Conferma nuova password" [feedback]="false" styleClass="w-full" inputStyleClass="w-full" autocomplete />
                <small class="text-red-600 block mt-2 font-medium" *ngIf="formUtente.hasError('mismatch') && (formUtente.get('password')?.dirty || formUtente.get('password')?.touched) && (formUtente.get('confirm_password')?.dirty || formUtente.get('confirm_password')?.touched)">Le due password non combaciano.</small>
            </div>
        </div>

        <div class="fld">
            <label>* Ruolo</label>
            <p-dropdown [options]="tipi" optionLabel="tipo" placeholder="Ruolo" formControlName="tipo" styleClass="w-full"></p-dropdown>
            <small class="text-red-600 block mt-2 font-medium" *ngIf="formUtente.get('tipo')?.hasError('required') && (formUtente.get('tipo')?.dirty || formUtente.get('tipo')?.touched)">Il ruolo è obbligatorio.</small>
        </div>

        <div class="acc-actions">
            <p-confirmPopup #confirmPopupRef>
                <ng-template pTemplate="headless" let-message>
                    <div class="border-round p-3">
                        <span class="text-base">{{ message.message }}</span>
                        <div class="flex align-items-center gap-2 mt-3">
                            <button type="button" class="acc-btn flex-1" (click)="onDelete()">Elimina</button>
                            <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onAnnulla()">Annulla</button>
                        </div>
                    </div>
                </ng-template>
            </p-confirmPopup>
            <button class="acc-btn" type="button" (click)="onDeletePopup($event)" [disabled]="utente?.id == 1 && user?.id !== 1">Elimina utente</button>
            <a class="acc-btn acc-btn-ghost" routerLink="/backoffice/utenti">Annulla</a>
            <button class="acc-btn acc-btn-primary" type="submit" [disabled]="!formUtente.valid">Salva modifiche</button>
        </div>
    </form>
</section>
